import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { ClientUserBranchAccessValidationSchema } from "../../schemas/companyBranches/updateUserAccesses.schema";
import { CompanyBranchData } from "../../types/companyBranches.type";
import { ErrorResponse } from "@/common/types/errorResponse";

interface UseCreateCompanyBranchUserAccessesProps {
  companyBranch?: CompanyBranchData;
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useCreateCompanyBranchUserAccesses = ({ companyBranch, onSuccess, onError }: UseCreateCompanyBranchUserAccessesProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createCompanyBranchUserAccesses', companyBranch?.id],
    mutationFn: (data: ClientUserBranchAccessValidationSchema) => {
      const payload = {
        user_branch_accesses_attributes: [
          {
            user_id: data.user.value,
            branch_hierarchy_for_user_access: data.branch_hierarchy_for_user_access.value,
          }
        ]
      }

      return privateAxios.put(`/client/company_branches/${companyBranch?.id}/update_user_accesses`, {
        company_branch: payload,
      });
    },
    onSuccess,
    onError,
  });
}
